module.exports = __webpack_public_path__ + "static/media/down_arrow_gray.88421798.svg";